import { Checkbox, Typography } from '@mui/material'
import { memo, useState } from 'react'
import { ActionsDialog } from '.'

interface Props {
  open: boolean
  onConfirm: () => void
  onCancel: () => void
  onChange: (value: boolean) => void
  title: string
  text: string
}

const HighEstimateDialog = ({ onConfirm, onCancel, open, title, text, onChange }: Props) => {
  const [isChecked, setIsChecked] = useState(false)

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target
    setIsChecked(checked)
    onChange(checked)
  }

  return (
    <ActionsDialog onCancel={onCancel} onConfirm={onConfirm} open={open} title={title} disabled={!isChecked}>
      <div
        style={{
          width: '45rem',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Checkbox checked={isChecked} onChange={handleCheckboxChange} />
        <Typography sx={{ mt: 2 }}>{text}</Typography>
      </div>
    </ActionsDialog>
  )
}

export default memo(HighEstimateDialog)
